import * as yup from 'yup';

export const getPartialRefundSchema = (
  fullAmount: number,
  currency_code: string
) =>
  yup.object({
    amount: yup
      .number()
      .typeError('Amount must be a number')
      .positive('Amount must be positive')
      .max(
        fullAmount,
        `Amount cannot exceed the total (${fullAmount} ${currency_code})`
      )
      .required('Amount is required')
  });
